import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';

import { TextFilter, TextTags, getTextApiParam } from './Text';


export const PhoneValue = React.memo((props) => {
  const {
    data
  } = props;
  
  
  return [data.mobile, data.phone].filter(Boolean).join(', ').trim() || '-';
});

export const PhoneFilter = TextFilter;

export const PhoneTags = TextTags;

export const getPhoneApiParam = getTextApiParam;

export const getPhoneExportValue = async (props, column, data) => {
  return [data.mobile, data.phone].filter(Boolean).join(', ').trim() || '-';
};
